export default __webpack_public_path__ + "static/burger-phone-e9f9490414864ebd554bc46c90b96549.png";